import * as React from "react";
import Paper from "@mui/material/Paper";
import { useEffect, useState } from "react";
import {
  Box,
  Button,
  Divider,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import SearchIcon from "@mui/icons-material/Search";
import Swal from "sweetalert2";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import PrintIcon from "@mui/icons-material/Print";
import axios from "axios";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import HOST_URL from '../../../utils/Url';
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import ToastApp from "../../../ToastApp";
import {
  DataGrid,
  GridColDef,
  GridToolbar,
} from "@mui/x-data-grid";
import Switch from "@mui/material/Switch";
import Chip from "@mui/material/Chip";
import CircularProgress from "@mui/material/CircularProgress";
import api from "../../../utils/Url";
import DataGrids from "../../../utils/Datagrids";
import dayjs from "dayjs";
import api2 from "../../../utils/Url2";

interface MenuPermission {
  isAdd: boolean;
  isEdit: boolean;
  isPrint: boolean;
  isDel: boolean;
}

export default function VehicleDetail() {
  const [item, setItem] = useState([]);
  const [columns, setColumns] = useState<any>([]);
  const [isLoading, setIsLoading] = useState(true);


  let navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {

    fetchVehicledetailData();

  }, [isLoading]);

  const routeChangeEdit = (row: any) => {
    console.log("row " + row);

    let path = `/Admin/masters/VehicleDetailEdit`;
    navigate(path, {
      state: row,
    });
  };

  const routeChangeAdd = () => {
    let path = `/Admin/masters/VehicleDetailAdd`;
    navigate(path);
  };

  let delete_id = "";
  const accept = () => {
    const collectData = {
      itemMasterId: delete_id
    }
    api
      .post(`ItemMaster/DeleteItemMaster`, collectData)
      .then((response) => {
        if (response.data.status === 1) {
          toast.success(response.data.message);
        } else {
          toast.error(response.data.message);
        }
        fetchVehicledetailData();
      });
  };

  const reject = () => {
    // toast.warn({summary: 'Rejected', detail: 'You have rejected', life: 3000 });
    toast.warn("Rejected: You have rejected", { autoClose: 3000 });
  };

  const handledeleteClick = (del_id: any) => {
    console.log(del_id + " del_id ");
    delete_id = del_id;
    confirmDialog({
      message: "Do you want to delete this record ?",
      header: "Delete Confirmation",
      icon: "pi pi-info-circle",
      acceptClassName: "p=-button-danger",
      accept,
      reject,
    });
  };

  const fetchVehicledetailData = async () => {
    try {
      const collectData = {
     "itemmasterid": -1,

      };
      const response = await api.post(`ItemMaster/GetItemMaster`, collectData);

      const data = response.data.data;
      const VehicleTypeWithIds = data.map((Item: any, index: any) => ({
        ...Item,
        SrNo: index + 1,
        id: Item.itemMasterId,
      }));
      setItem(VehicleTypeWithIds);
      setIsLoading(false);

      if (data.length > 0) {
        const columns: GridColDef[] = [
          {
            field: "actions",
            headerClassName: "MuiDataGrid-colCell",
            headerName: t("text.Action"),
            width: 150,

            renderCell: (params) => {
              return [
                <Stack
                  spacing={1}
                  direction="row"
                  sx={{ alignItems: "center", marginTop: "5px" }}
                >
                  {/* {permissionData?.isEdit ? ( */}
                  <EditIcon
                    style={{
                      fontSize: "20px",
                      color: "blue",
                      cursor: "pointer",
                    }}
                    className="cursor-pointer"
                    onClick={() => routeChangeEdit(params.row)}
                  />
                  {/* ) : ( */}
                  {/* "" */}
                  {/* )} */}
                  {/* {permissionData?.isDel ? ( */}
                  <DeleteIcon
                    style={{
                      fontSize: "20px",
                      color: "red",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      handledeleteClick(params.row.id);
                    }}
                  />
                </Stack>,
              ];
            },
          },

          {
            field: "SrNo",
            headerName: t("text.SrNo"),
            flex: 1,
            headerClassName: "MuiDataGrid-colCell",
          },
          {
            field: "itemName",
            headerName: t("text.Name"),
            flex: 1,
            headerClassName: "MuiDataGrid-colCell",
          },
          {
            field: "vehicleNo",
            headerName: t("text.VehicleNos"),
            flex: 1,
            headerClassName: "MuiDataGrid-colCell",
            // renderCell(params) {
            //   return dayjs(params.row.mrnDate).format("DD-MMM-YYYY")
            // },
          },
          // {
          //   field: "UnderControlOF",
          //   headerName: t("text.UnderControlOFs"),
          //   flex: 1,
          //   headerClassName: "MuiDataGrid-colCell",
          // },
          {
            field: "zoneName",
            headerName: t("text.Zone"),
            flex: 1,
            headerClassName: "MuiDataGrid-colCell",
          },
          // {
          //   field: "department",
          //   headerName: t("text.Departments"),
          //   flex: 1,
          //   headerClassName: "MuiDataGrid-colCell",
          // },

          // {
          //   field: "designationName",
          //   headerName: t("text.Designations"),
          //   flex: 1,
          //   headerClassName: "MuiDataGrid-colCell",
          // },
          // {
          //   field: "PurchaseYear",
          //   headerName: t("text.PurchaseYear"),
          //   flex: 1,
          //   headerClassName: "MuiDataGrid-colCell",
          // },
          {
            field: "vehicleTypeName",
            headerName: t("text.VehicleTypeName11"),
            flex: 1,
            headerClassName: "MuiDataGrid-colCell",
          },
          // {
          //   field: "FuelAlloted",
          //   headerName: t("text.FuelAlloted"),
          //   flex: 1,
          //   headerClassName: "MuiDataGrid-colCell",
          // },
          // {
          //   field: "KmPerLitre",
          //   headerName: t("text.KmPerLitre"),
          //   flex: 1,
          //   headerClassName: "MuiDataGrid-colCell",
          // },
          // {
          //   field: "LitrePerHour",
          //   headerName: t("text.LitrePerHour"),
          //   flex: 1,
          //   headerClassName: "MuiDataGrid-colCell",
          // },
          // {
          //   field: "Category",
          //   headerName: t("text.Category"),
          //   flex: 1,
          //   headerClassName: "MuiDataGrid-colCell",
          // },
          // {
          //   field: "netAmount",
          //   headerName: t("text.NetAmount"),
          //   flex: 1,
          //   headerClassName: "MuiDataGrid-colCell",
          // },
        ];
        setColumns(columns as any);
      }

    } catch (error) {
      console.error("Error fetching data:", error);
      // setLoading(false);
    }
  };

  const adjustedColumns = columns.map((column: any) => ({
    ...column,
  }));


  return (
    <>
      <Card
        style={{
          width: "100%",
          // height: "100%",
          backgroundColor: "#E9FDEE",
          border: ".5px solid #FF7722 ",
          marginTop: "3vh"
        }}
      >
        <Paper
          sx={{
            width: "100%",
            overflow: "hidden",
            "& .MuiDataGrid-colCell": {
              backgroundColor: `var(--grid-headerBackground)`,
              color: `var(--grid-headerColor)`,
              fontSize: 17,
              fontWeight: 900
            },
          }}
          style={{ padding: "10px", }}
        >
          <ConfirmDialog />

          <Typography
            gutterBottom
            variant="h5"
            component="div"
            sx={{ padding: "20px" }}
            align="left"
          >
            {t("text.VehicleDetail")}
          </Typography>
          <Divider />

          <Box height={10} />

          <Stack direction="row" spacing={2} classes="my-2 mb-2">
            {/* {permissionData?.isAdd == true && ( */}
            <Button
              onClick={routeChangeAdd}
              variant="contained"
              endIcon={<AddCircleIcon />}
              size="large"
              style={{ backgroundColor: `var(--header-background)` }}
            >
              {t("text.add")}
            </Button>
            {/* ) } */}

          </Stack>


          <DataGrids
            isLoading={isLoading}
            rows={item}
            columns={adjustedColumns}
            pageSizeOptions={[5, 10, 25, 50, 100]}
            initialPageSize={5}
          />
        </Paper>
      </Card>
      <ToastApp />

    </>
  );
}
